import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useMembersGroupUser";
import {PrimaryMembersGroupUser} from "../../../types/models/MembersGroupUser";
import {useGetMembersGroupUserQuery} from "../../../apis/MembersGroupUser.api";
import MembersGroupUserUpdateForm, {formSchema, initialFormStateFn} from "../../../components/membersGroupUser/MembersGroupUserForm/MembersGroupUserUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const MembersGroupUserUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryMembersGroupUser.fromPath(id);
    const { data, isLoading } = useGetMembersGroupUserQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    
                    noValidate
                >

                    <MembersGroupUserUpdateForm watch={watch}/>

                    <Stack direction="row" spacing={1} sx={{ justifyContent: "end", padding: 5 }}>

                        { cancelButton }

                        
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default MembersGroupUserUpdateFormProvider
